import { render, staticRenderFns } from "./JobPreviewRequirementsSp.vue?vue&type=template&id=a53f6e18&scoped=true"
import script from "./JobPreviewRequirementsSp.vue?vue&type=script&lang=js"
export * from "./JobPreviewRequirementsSp.vue?vue&type=script&lang=js"
import style0 from "./JobPreviewRequirementsSp.vue?vue&type=style&index=0&id=a53f6e18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53f6e18",
  null
  
)

export default component.exports